package world.phantasmal.web.core

enum class PwToolType(val uiName: String, val slug: String) {
    QuestEditor("Quest Editor", "quest_editor"),
    Viewer("Viewer", "viewer"),
    HuntOptimizer("Hunt Optimizer", "hunt_optimizer"),
}
